module.exports = __webpack_public_path__ + "static/yazan-header-logo-7aef500866cb95d623b9b21422beab3a.png";